












import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {
  @Prop({ default: -1 })
  public value!: number;

  @Prop({ required: true })
  public id!: string;

  @Emit("input")
  private onInput(evt: Event) {
    if (evt.target) {
      const inputValue = (evt.target as HTMLInputElement).value;
      return inputValue === "" ? inputValue : +inputValue;
    }
    return "";
  }

  get empty(): boolean {
    return this.value < 0 || this.value.toString() == "";
  }
}
